import React, { useRef } from 'react';
import { CgShoppingCart } from 'react-icons/cg';
import PropTypes from 'prop-types';
import { FLYOUT_BASKET_CLASS_NAME } from './constants';
import { getLeftOffset, getTopOffset } from '../../helpers';

const FlyOutBasketTotal = ({ handleOnClick, quantity, totalPrice }) => {
  const ref = useRef(null);

  const onClick = e => {
    if (typeof window === 'undefined' || !ref.current) return;
    const { left, top } = ref.current.getBoundingClientRect();
    const offsetTopToUse = getTopOffset(top);
    const offsetLeftToUse = getLeftOffset(left);
    handleOnClick(offsetTopToUse, offsetLeftToUse);
  };

  const className = `${FLYOUT_BASKET_CLASS_NAME}__total`;

  return (
    <div className={className} ref={ref}>
      <div className={`${className}__total-icon`}>
        <CgShoppingCart />
      </div>
      <span role="button" className={`${className}__total-text`} onClick={onClick}>
        {quantity} Items: {totalPrice}
      </span>
    </div>
  );
};

FlyOutBasketTotal.propTypes = {
  handleOnClick: PropTypes.func.isRequired,
  quantity: PropTypes.string,
  totalPrice: PropTypes.string
};

FlyOutBasketTotal.defaultProps = {
  quantity: null,
  totalPrice: null
};

export default FlyOutBasketTotal;
